import { Components, Theme } from '@mui/material';
import { CHIP_HEIGHT } from '../../Chip/overrides';

export default {
  defaultProps: {
    openOnFocus: true,
    fullWidth: true,
    slotProps: {
      chip: {
        size: 'small',
        variant: 'outlined',
        'data-test-id': 'input-chip',
      }
    }
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const autocompleteStyles = {
        '& .MuiOutlinedInput-root': {
          paddingRight: `${theme.spacing(2)}!important`, // To override padding for custom end adornment
          '&:hover, &.Mui-error': {
            paddingRight: `${theme.spacing(5.5)}!important`
          },
        },
        '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
          maxWidth: `calc(100% - ${theme.spacing(4.5)})!important`, // Prevent label overlap with dropdown arrow icon
          '&.Mui-error': {
            maxWidth: `calc(100% - ${theme.spacing(8)})!important`, // Prevent label overlap with error icon
          },
        },
        '& .arrow-drop-down-icon': {
          cursor: 'pointer',
          '&.open': {
            transform: 'rotate(180deg)'
          }
        },
      };
      const multipleStyles = {
        '& .MuiAutocomplete-tag': {
          padding: 2
        },
        '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
          minWidth: 'unset',
        },
        '& .MuiAutocomplete-input': {
          padding: '0!important',
          '&:focus-within': {
            minWidth: 'unset',
            flex: 1,
            padding: '2.5px 4px 2.5px 6px!important'
          }
        },
        '& .MuiOutlinedInput-root': {
          paddingRight: `${theme.spacing(5.5)}!important`, // To override padding for custom end adornment
          paddingTop: '5px!important',
          paddingBottom: '5px!important',
        }
      };

      if (ownerState.multiple && ownerState.value.length) {
        return { ...autocompleteStyles, ...multipleStyles };
      } else {
        return autocompleteStyles;
      }
    },
    tag: {
      height: CHIP_HEIGHT.SMALL,
      boxSizing: 'border-box',
    },
    paper: ({ theme }) => {
      return {
        padding: theme.spacing(0.5),
        backgroundColor: theme.palette.neutral.containerHighest,
        '& .MuiLinearProgress-root': {
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
        },
        ...theme.typography.body2,
      };
    },
    groupUl: {
      margin: 0,
    },
    listbox: {
      padding: 0,
      overflow: 'hidden',
      maxHeight: 'unset',
    }
  },

} as Components<Theme>['MuiAutocomplete'];